import React from 'react'
import i1 from '../assets/intro2.png'
import i2 from '../assets/intro2.png'
import {
 
  FaGithub,
  FaLinkedin,
  FaMailBulk,
  FaSlack,
  FaStar,
 
} from "react-icons/fa";

const Aboutme = () => {
    const iconStyle={
        backgroundColor: "var(--white)",
                  fontSize: "25px",
                  fontWeight: "800",
                  color: "var(--green)",
                  // border: "2px solid var(--secondary)",
                  borderRadius:"50%",
                  margin:"9px 1px",
                  padding:"7px"
                 
      }
  return (
    <>
    <section class="about-me" id="about-me" >
    <div class="container">
      <div class="about-me-container">
        <div  className='sec-title'>
         About Me
        </div>
  
        <div class="about-me-flex-container">
          <div class="about-me-image">
            <div class="back-div"></div>
            <div class="black-image"><img src={i2} alt="black"/></div>
            <div class="main-image"><img src={i1} alt="smit"/></div>
          </div>
          <div class="about-me-content">
  
          
  <h3 style={{color:"#AC3B61",fontSize:"20px"}}>
Kashaf Abdullah
<br />
      Web Developer & Designer
  </h3>
            <div className="text">
            
            As a passionate web developer with a flair for design and a knack for problem-solving, I am dedicated to crafting exceptional digital experiences. With a robust foundation in the MERN stack (MongoDB, Express.js, React, and Node.js), I bring a comprehensive approach to developing dynamic, responsive, and user-friendly web applications
              <br/><br/>
  
              My journey in the tech industry has been marked by a continuous desire to learn and innovate, driving me to stay updated with the latest trends and best practices. Whether I am optimizing existing code, designing new features, or collaborating with teams to bring a project to life, my goal is always to create seamless and engaging digital experiences.<br />

<br />

<strong>I am eager to bring my creative vision and technical prowess to new projects, ready to contribute to building the next generation of web applications</strong>

                </div>
          </div>
        </div>
  
        <div class="mail-button mail-button2">
          {/* <a href="mailto:prajapatismit2906@gmail.com"><img src="https://raw.githubusercontent.com/Smit-Prajapati/prajapatismit/20391be8bf1ed24ef0e5da066bf68a5f6ee78fa1/images/mail.svg" alt="mail"/></a> */}
      
<div className="logo-social-media" style={{ margin: "1rem 0" }}>
        
        <a className='button-85' href="https://www.linkedin.com/in/kashaf-abdullah-482246207/" target="_blank" rel="noopener noreferrer"  style={iconStyle}>
              <FaLinkedin style={{position:"relative",bottom:"2px"}}/>
            </a>
        
            <a className='button-85' href="https://github.com/Kashaf-Abdullah/" target="_blank" rel="noopener noreferrer"  style={iconStyle}>
              <FaGithub style={{position:"relative",bottom:"2px"}}/>
            </a>
        
            <a className='button-85' href="mailto: kashafabdullah01@gmail.com" target="_blank" rel="noopener noreferrer"  style={iconStyle}>
              <FaMailBulk style={{position:"relative",bottom:"2px"}}/>
            </a>
        
        
            <a className='button-85' href="" target="_blank" rel="noopener noreferrer"  style={iconStyle}>
              <FaSlack style={{position:"relative",bottom:"2px"}}/>
            </a>
          
                 </div>
               
        </div>
  
      </div>
  
    </div>
  </section>
  
  
  
  
  
  
  <br/><br/>

  
  </>)
}

export default Aboutme
